module.exports = __webpack_public_path__ + "static/media/proyecciones.e2cc00d5.svg";